import React from 'react'
import Footer from '../Footer/Footer'
import Header from '../Header'

const Guideline = () => {
  return (
    <div>
        <Header />
        <Footer />
    </div>
  )
}

export default Guideline